const state ={
    desc:'关于太药'
  }
  const mutations = {}
  const actions = {}
  const getters={}
  export default {
    state,
    mutations,
    actions,
    getters
  }